import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable, TemplateRef } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';

export interface SgTopNavElement {
  type: 'header' | 'rElement' | 'vertMenuElement';
  templateRef: TemplateRef<any>;
  menuTriggerFor: MatMenuPanel;
  vertMenuType: 'button' | 'menuButton' | 'element';
}

@Injectable()
export class SgTopNavService {
  headerItems$: Observable<SgTopNavElement[]>;
  menuItems$: Observable<SgTopNavElement[]>;
  navbarItems$: Observable<SgTopNavElement[]>;
  isOnColor$: Observable<boolean>;

  private headerItems: BehaviorSubject<SgTopNavElement[]>;
  private menuItems: BehaviorSubject<SgTopNavElement[]>;
  private navbarItems: BehaviorSubject<SgTopNavElement[]>;
  private isOnColor: BehaviorSubject<boolean>;

  constructor() {
    this.headerItems = new BehaviorSubject<SgTopNavElement[]>([]);
    this.menuItems = new BehaviorSubject<SgTopNavElement[]>([]);
    this.navbarItems = new BehaviorSubject<SgTopNavElement[]>([]);
    this.isOnColor = new BehaviorSubject<boolean>(false);
    this.headerItems$ = this.headerItems.asObservable();
    this.menuItems$ = this.menuItems.asObservable();
    this.navbarItems$ = this.navbarItems.asObservable();
    this.isOnColor$ = this.isOnColor.asObservable();
  }

  setIsOnColor(value: boolean): void {
    this.isOnColor.next(value);
  }

  addElement(element: SgTopNavElement): void {
    switch (element.type) {
      case 'header':
        this.headerItems.next(this.headerItems.value.concat([element]));
        break;
      case 'rElement':
        this.navbarItems.next(this.navbarItems.value.concat([element]));
        break;
      case 'vertMenuElement':
        this.menuItems.next(this.menuItems.value.concat([element]));
        break;
    }
  }

  removeElement(element: SgTopNavElement): void {
    switch (element.type) {
      case 'header':
        this.remove(element, this.headerItems);
        break;
      case 'rElement':
        this.remove(element, this.navbarItems);
        break;
      case 'vertMenuElement':
        this.remove(element, this.menuItems);
        break;
    }
  }

  private remove<T>(btn: T, coll: BehaviorSubject<T[]>): boolean {
    const idx = coll.value.indexOf(btn);
    if (idx > -1) {
      const newColl = coll.value.slice();
      newColl.splice(idx, 1);
      coll.next(newColl);
      return true;
    }
    return false;
  }
}
